import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { DataService } from "src/app/services/data.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "src/app/services/auth.service";
import { Router } from "@angular/router";
import { HostListener } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit {
  cateData: any = [];
  suggestContent: FormGroup;
  @ViewChild("suggestModal") suggestModal: ElementRef;
  user: any = {};
  message = "";
  isDropdownOpen = false;
  isMobile = false;
  loader = false;

  constructor(
    private dataService: DataService,
    private _fb: FormBuilder,
    private afs: AngularFirestore,
    public authService: AuthService,
    private router: Router,
    private _snackBar: MatSnackBar
  ) {}

  async ngOnInit() {
    this.user = this.dataService.userDetail;
    //console.log(this.user);
    (await this.dataService.getCategoryService()).subscribe((singleservice) => {
      this.cateData = [];
      this.cateData = singleservice.filter((c: any) => !c.isAICategory);
    });
    this.suggestContent = this._fb.group({
      suggestions: [""],
      status: ["Active"],
    });
    this.updateDevice();
  }

  @HostListener("window:resize", [])
  onWindowResize() {
    this.updateDevice();
  }

  updateDevice() {
    this.isMobile = window.innerWidth < 768;
  }

  toggleDropdown(event: Event) {
    if (this.isMobile) {
      event.preventDefault(); // prevent anchor jump
      this.isDropdownOpen = !this.isDropdownOpen;
    }
  }

  onHover(hovering: boolean) {
    if (!this.isMobile) {
      this.isDropdownOpen = hovering;
    }
  }

  async submitContent(data, valid) {
    //console.log(data);

    if (valid) {
      this.loader = true;
      data["createdAt"] = new Date().toString();
      data["createdOn"] = +new Date();
      await this.afs.collection("suggesstions").add(data);
      this.suggestContent.reset();
      this.suggestModal.nativeElement.click();
      this._snackBar.open(
        "We've received your custom illustration request successfully.",
        "Okay",
        {
          duration: 1000,
        }
      );
      // this.message = "Submitted Successfully";
      // setTimeout(() => {
      //   this.message = "";
      //   this.suggestModal.nativeElement.click();
      // }, 1000);
      return true;
    } else return false;
  }

  logout() {
    this.authService.logout();
  }

  navigateToLogin() {
    const currentUrl = this.router.url;
    sessionStorage.setItem("returnUrl", currentUrl);
    this.router.navigate(["/login"]);
  }

  onImageError(event: any) {
    event.target.src = "assets/img/avatar.png";
  }
}
